// extracted by mini-css-extract-plugin
module.exports = {"addToCartBtn":"styles_addToCartBtn__5xv4h","labelWrapper":"styles_labelWrapper__Kyze7"};